import { ArrowRight, BadgeCheck, Clock3, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { AgencySummary } from '../lib/types';

export function AgencyCard({ agency, compact = false, action }: { agency: AgencySummary; compact?: boolean; action?: React.ReactNode }) {
  const initials = agency.name.split(/\s+/).slice(0, 2).map(word => word[0]).join('').toUpperCase();
  return (
    <div className={`agency-card ${compact ? 'compact' : ''}`}>
      <div className="agency-main">
        <div className="agency-logo">{agency.logoUrl ? <img src={agency.logoUrl} alt="" loading="lazy" decoding="async" /> : initials}</div>
        <div>
          <div className="agency-name">{agency.name} {agency.verification_tier && agency.verification_tier !== 'unverified' && <BadgeCheck size={16} />}</div>
          <div className="agency-meta"><Star size={14} fill={(agency.review_count ?? 0) > 0 ? 'currentColor' : 'none'} /> {(agency.review_count ?? 0) > 0 ? `${(agency.average_rating ?? 0).toFixed(1)} · ${agency.review_count} review${agency.review_count === 1 ? '' : 's'}` : 'No reviews yet'} · <Clock3 size={14} /> {agency.response_time_minutes ? `${agency.response_time_minutes} min` : 'New'}</div>
        </div>
      </div>
      {!compact && (
        <div className="agency-stats">
          <div><strong>{agency.verified_placement_count ?? 0}</strong><span>Verified placements</span></div>
          <div><strong>{agency.contribution_score ?? 0}/100</strong><span>Contribution impact</span></div>
        </div>
      )}
      {action || <Link className="text-link" to={`/agencies/${agency.slug}`}>View profile <ArrowRight size={15} /></Link>}
    </div>
  );
}
